// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1rOta","range":"MonthRangeSwitch_range__1MVOL","disabled":"MonthRangeSwitch_disabled__2TLhJ"};